/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Just_NowInputs */

const fr_marker_just_now = /** @type {(inputs: Marker_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`à l'instant`)
};

const en_marker_just_now = /** @type {(inputs: Marker_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`just now`)
};

/**
* | output |
* | --- |
* | "just now" |
*
* @param {Marker_Just_NowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_just_now = /** @type {((inputs?: Marker_Just_NowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Just_NowInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_just_now(inputs)
	return en_marker_just_now(inputs)
});